import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireAuth } from '../lib/auth/guards';
import { AppShell } from '../components/layout/AppShell';
import { PageHeaderProvider } from '../components/layout/PageHeaderContext';

// Layout route. Every child of /_authenticated/* runs through this
// beforeLoad guard before its component is mounted; the guard either
// resolves (session present) or throws a redirect to /login carrying
// the intended destination.
//
// PageHeaderProvider wraps AppShell so the top bar can read the
// page's title/subtitle set by the routed page via useSetPageHeader.
export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ location }) => {
    await requireAuth({ pathname: location.pathname, search: location.search });
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout(): JSX.Element {
  return (
    <PageHeaderProvider>
      <AppShell>
        <Outlet />
      </AppShell>
    </PageHeaderProvider>
  );
}
